(function() {
  'use strict';

  const STORAGE_KEY = 'brand_promo_clicked';
  const STORAGE_EXPIRY = 30 * 60 * 1000; // 30 minutes

  // Get clicked promo from Cookie
  function getClickedPromo() {
    const match = document.cookie.match(/(?:^|; )brand_promo_clicked=([^;]*)/);
    if (!match) return null;
    try {
      const data = JSON.parse(decodeURIComponent(match[1]));
      if (Date.now() > data.expiry) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  // Store clicked promo in Cookie
  function setClickedPromo(brand, placement) {
    try {
      const data = JSON.stringify({
        brand: brand,
        placement: placement,
        expiry: Date.now() + STORAGE_EXPIRY
      });
      document.cookie = "brand_promo_clicked=" + encodeURIComponent(data) + "; path=/; max-age=1800";
    } catch (e) {}
  }

  // DIRECT GA4 FETCH (Bypasses GTM and dataLayer entirely)
  function trackEvent(eventName, params) {
    const measurementId = 'G-S1RK9DR99K';
    
    // Extract GA4 Client ID from the _ga cookie
    let clientId = '123456789.123456789';
    const gaMatch = document.cookie.match(/(?:^|; )_ga=([^;]*)/);
    if (gaMatch) {
      const parts = gaMatch[1].split('.');
      if (parts.length >= 2) clientId = parts.slice(-2).join('.');
    }

    // Extract session ID from _ga_<container> cookie
    let sessionId = '';
    const sessionMatch = document.cookie.match(/(?:^|; )_ga_[A-Z0-9]+=([^;]*)/);
    if (sessionMatch) {
      const sParts = sessionMatch[1].split('.');
      if (sParts.length >= 3) sessionId = sParts[2];
    }

    let url = `https://www.google-analytics.com/g/collect?v=2&tid=${measurementId}&cid=${clientId}&en=${eventName}`;
    if (sessionId) url += `&sid=${sessionId}&_s=1`;

    // Format parameters for GA4
    const epParams = {};
    for (const key in params) {
      epParams['ep.' + key] = params[key];
    }
    const queryString = new URLSearchParams(epParams).toString();

    // Send directly to Google
    fetch(`${url}&${queryString}`, { method: 'POST', mode: 'no-cors' }).catch(()=>{});
  }


  function vendorMatchesBrand(vendor, brand) {
    if (!vendor || !brand) return false;
    return vendor.toLowerCase().includes(brand.toLowerCase());
  }

  function trackImpressions() {
    document.querySelectorAll('[data-promo-brand]').forEach(function(promo) {
      trackEvent('brand_promo_impression', {
        promo_brand: promo.dataset.promoBrand,
        promo_placement: promo.dataset.promoPlacement
      });
    });
  }

  function trackClicks() {
    document.querySelectorAll('[data-promo-click]').forEach(function(link) {
      link.addEventListener('click', function() {
        const promo = this.closest('[data-promo-brand]');
        if (!promo) return;
        
        const brand = promo.dataset.promoBrand;
        const placement = promo.dataset.promoPlacement;
        
        setClickedPromo(brand, placement);
        
        trackEvent('brand_promo_click', {
          promo_brand: brand,
          promo_placement: placement
        });
      });
    });
  }

  function trackAddToCart() {
    const originalFetch = window.fetch;
    window.fetch = function() {
      const fetchArgs = arguments;
      return originalFetch.apply(this, fetchArgs).then(function(response) {
        const url = fetchArgs[0];
        if (typeof url === 'string' && url.includes('/cart/add')) {
          response.clone().json().then(function(data) {
            const promo = getClickedPromo();
            if (!promo) return;
            
            // Handle both single item and multiple items arrays
            const items = data.items || [data];
            items.forEach(function(item) {
              if (item.vendor && vendorMatchesBrand(item.vendor, promo.brand)) {
                trackEvent('brand_promo_add_to_cart', {
                  promo_brand: promo.brand,
                  promo_placement: promo.placement,
                  product_vendor: item.vendor
                });
              }
            });
          }).catch(function(){});
        }
        return response;
      });
    };
  }

  function trackCheckout() {
    document.addEventListener('click', function(e) {
      const checkoutBtn = e.target.closest('[name="checkout"], .cart__checkout-button, [href*="/checkout"]');
      if (!checkoutBtn) return;
      
      const promo = getClickedPromo();
      if (!promo) return;

      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          const hasBrandProduct = cart.items.some(function(item) {
            return vendorMatchesBrand(item.vendor, promo.brand);
          });
          
          if (hasBrandProduct) {
            trackEvent('brand_promo_checkout_start', {
              promo_brand: promo.brand,
              promo_placement: promo.placement
            });
          }
        }).catch(function(){});
    });
  }

  function init() {
    trackImpressions();
    trackClicks();
    trackAddToCart();
    trackCheckout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
